import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
import { TransferOfferStatusEnum } from "@/modules/transfer-market/enums";
import { app } from "@/di";
import { NegotiationComponentManager } from "@/modules/diplomacy/services/NegotiationComponentManager";
export default /*#__PURE__*/_defineComponent({
  __name: 'TransferOffer',
  props: {
    offer: null,
    team: null,
    season: null
  },
  emits: ['updated'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const manager = app.get(NegotiationComponentManager);
    const colorMap = ref({
      [TransferOfferStatusEnum.OPENED]: ColorEnum.Green,
      [TransferOfferStatusEnum.CLOSED]: ColorEnum.Blue,
      [TransferOfferStatusEnum.FAILED]: ColorEnum.Red
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(manager).getComponent(__props.offer.teamNegotiation)), {
        negotiation: __props.offer.teamNegotiation,
        "hide-alert": "",
        "not-closable": "",
        "not-abortable": "",
        class: "rounded mb-4 border",
        onClosed: _cache[0] || (_cache[0] = () => emit('updated')),
        onUpdated: _cache[1] || (_cache[1] = () => emit('updated'))
      }, null, 40, ["negotiation"])), (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(manager).getComponent(__props.offer.playerNegotiation)), {
        negotiation: __props.offer.playerNegotiation,
        "hide-alert": "",
        "not-closable": "",
        "not-abortable": "",
        class: "rounded bg-slate-50 mb-4 border",
        onClosed: _cache[2] || (_cache[2] = () => emit('updated')),
        onUpdated: _cache[3] || (_cache[3] = () => emit('updated'))
      }, null, 40, ["negotiation"]))]);
    };
  }
});